import { Components, Theme } from '@mui/material';

export const MuiTableRow: Components<Theme>['MuiTableRow'] = {
  styleOverrides: {
    hover: {
      cursor: 'pointer',
    },
  },
};
